import { createRouter, createWebHistory } from "vue-router";

import HomePage from "../components/HomePage.vue";

// components/structure
import AnimauxVue from "../components/AnimauxVue.vue";
import RefugeAssoVue from "../components/RefugeAssocie.vue";
import AproposVue from "../components/AproposVue.vue";
import HomePageArticle from "../components/HomePageArticle.vue";
import ArticleVue from "../components/ArticleVue.vue";
import ContactVue from "../components/ContactVue.vue";
import RgpdVue from "../components/RgpdVue.vue";
import SponsorVue from "../components/SponsorVue.vue";
import AnimalDetail from "../components/AnimauxDetails.vue";
import Faq from "../components/FaqVue.vue";


const routes = [
    { path: "/", name: "home", component: HomePage },

    { path: "/animaux", name: "animaux", component: AnimauxVue },
    { path: "/refuges", name: "refuges", component: RefugeAssoVue },
    { path: "/projet", name: "projet", component: AproposVue },
    { path: "/faq", name: "Faq", component: Faq },


    // Blog (liste + détail)
    { path: "/blog", name: "blog", component: HomePageArticle },
    { path: "/article", name: "blog-article", component: ArticleVue, },


    {
        path: "/animal/:id",
        name: "animalDetail",
        component: AnimalDetail
    },

    { path: "/contact", name: "contact", component: ContactVue },
    { path: "/rgpd", name: "rgpd", component: RgpdVue },
    { path: "/sponsor", name: "sponsor", component: SponsorVue },

    // fallback
    { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { top: -50 };
    },
});

export default router;